import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { AIFormSubmissionState, shouldFormBeBlocked } from '../../../03_model/ai-chat-message.model';

@Component({
  selector: 'tps-assistant-form-shell',
  imports: [
    MatProgressBarModule,
  ],
  templateUrl: './assistant-form-shell.component.html',
  styleUrls: ['./assistant-form-shell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AssistantFormShellComponent {

  submissionState = input<AIFormSubmissionState>('idle');
  errorMessage = input<string | null | undefined>(null);

  blocked = shouldFormBeBlocked(this.submissionState);
  submitting = computed(() => this.submissionState() === 'submitting');
}
